import React, { useMemo, useState, useEffect } from "react";
import {
  Modal,
  Steps,
  Button,
  Form,
  Select,
  Row,
  Col,
  Input,
  InputNumber,
  Popconfirm,
  Spin,
  Table,
  message,
  Drawer,
  Checkbox,
  Space,
  Segmented,
  Tooltip,
} from "antd";
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  FileSearchOutlined,
  CloseOutlined,
  EyeOutlined,
  EditOutlined,
  SaveOutlined,
} from "@ant-design/icons";

// ✅ Servicios movidos al hijo para evitar duplicación en el padre
import { getParticipantesSostenibilidad } from "../../services/financiero/plandecompras/getPlanesSostenibilidad";
import {
  getProductos,
  postAsignaciones,
} from "../../services/financiero/productos/getProductos";
import { useSelector } from "react-redux";
import "./Asignacion.css";
import PoPicker from "./PoPicker";
import {
  deleteAsignacionById,
  getAsignacionesByIds,
  getCounDisponibleProductPOById,
  getPlanCompraSostenibilidadById,
  getPlanesCompraSostenibilidad,
  updateAsignacionById,
} from "../../services/financiero/plandecompras/planesdecomprasostenibilidad";
import AsignacionesModal from "./AsignacionesModal";
import { getSalidasByIds } from "../../services/entregas/servicesEntregas";
import EntregasModal from "./EntregasModal";
import { actualizarFactorSubfactorPlanCompraService } from "../../services/financiero/plandecompras/updatePlandecomprasSostenibilidad";

const CURRENCY = (n = 0) =>
  new Intl.NumberFormat("es-CO", {
    style: "currency",
    currency: "COP",
    minimumFractionDigits: 0,
  }).format(Number(n) || 0);
const SECTIONS = [
  { key: "infraestructura", title: "A. Infraestructura" },
  { key: "activos", title: "B. Activos Productivos y Equipos" },
  { key: "herramientas", title: "C. Herramientas y Mobiliario" },
  { key: "insumos", title: "D. Insumos" },
  { key: "gastos", title: "E. Gastos Operativos" },
  { key: "contrapartida", title: "F. Contrapartida" },
];

const factores = [
  {
    factor: "Factor 1. Acompañamiento y fortalecimiento técnico y financiero",
    subfactores: [
      "El proyecto productivo funciona bajo un modelo técnico que le permite obtener resultados productivos esperados en la formulación del proyecto productivo en términos de oportunidad y calidad del producto y/o servicios ofrecidos.",
      "El proyecto productivo cuenta con personal capacitado para el manejo adecuado del modelo productivo y financiero",
      "La capacidad instalada en términos de activos productivos (Ej: herramientas, equipos, maquinaria, instalaciones físicas, inventarios, material vegetal y animal, principalmente) es suficiente para el desarrollo del modelo técnico productivo del proyecto productivo",
      "Las decisiones financieras del proyecto productivo se toman con base en herramientas e informes contables y administrativos.",
      "Los ingresos de la actividad productiva permiten cubrir los costos operativos, reinvertir en la producción y mantener el capital de trabajo (punto de equilibrio)",
    ],
  },
  {
    factor: "Factor 2. Fortalecimiento organizativo y asociativo",
    subfactores: [
      "La forma asociativa o el colectivo de trabajo cumple las obligaciones tributarias y administrativas.",
      "Las actividades programadas en el PRE PPC se desarrollan bajo una estructura de coordinación y gerencia, orientada por la forma asociativa",
      "Las personas vinculadas al proyecto productivo conocen del desarrollo del mismo y participan en la toma de decisiones y la gestión de acciones.",
      "La forma asociativa o el colectivo de trabajo aplica mecanismos para el trámite asertivo de conflictos internos.",
    ],
  },
  {
    factor:
      "Factor 3. Acompañamiento y fortalecimiento a procesos de mercadeo y comercialización",
    subfactores: [
      "El proyecto productivo comercializa la totalidad de sus bienes/servicios producidos.",
      "El proyecto productivo cuenta e implementa una estrategia de mercadeo y comercialización adecuada para cumplir sus objetivos.",
      "En opinión de los clientes el proyecto productivo cumple con los requerimientos de: precio, cantidad, calidad y oportunidad de entrega.",
    ],
  },
  {
    factor:
      "Factor 4. Acompañamiento y gestión para la articulación e incidencia territorial ",
    subfactores: [
      "Las relaciones entre las y los participantes, las comunidades aledañas y las organizaciones con incidencia territorial se manifiestan en acciones de desarrollo social, productivo y construcción de agendas territoriales.",
      "El proyecto productivo y sus gestores han logrado articularse con actores, planes, programas y proyectos público/privados/cooperación internacional en el marco de la planeación local, regional y nacional.",
      "El proyecto productivo y las comunidades se articulan entre si a las cadenas de valor territoriales de forma directa o indirecta (ej: empleos, proveeduría, producción, comercialización).",
      "El proyecto productivo se articula con redes productivas que aportan a su sostenibilidad (ej: Coordinadora de Federaciones, Federaciones, Mesa Nacional de Café, de Piscicultura, Red Renace, otros PPC, proyecto confederativo, etc) ",
      "El proyecto productivo tiene prácticas adecuadas con la vocación ambiental, productiva y sociocultural del territorio. ",
      "La cohesión y fortalecimiento interno del proyecto productivo le permite asumirse como poder movilizador en el territorio.",
    ],
  },
  {
    factor:
      "Factor 5. Implementación de los enfoques de género, étnico y diferenciales ",
    subfactores: [
      "Los procesos productivos y organizativos desarrollan acciones para incluir la perspectiva, intereses, motivaciones, necesidades y facilitar la participación de las personas que se autoreconocen como parte de grupos étnicos, LGBTIQ+, personas con discapacidad, jóvenes y/o adultos mayores.",
      "La forma asociativa o el colectivo de trabajo motiva/promueve la participación efectiva y el liderazgo de las mujeres en los procesos productivos y de dirección del proyecto productivo y de la misma forma asociativa.   * Participación efectiva: vinculación a espacios decisorios y productivos para garantizar la vinculación de las mujeres en los procesos del proyecto productivo.",
      "Se han previsto o incorporado acciones que propenden por la autonomía económica de las mujeres, el fortalecimiento de espacios y los mecanismos de cuidado.",
    ],
  },
  {
    factor: "Factor 6. Tierras y predios urbanos ",
    subfactores: [
      "El predio en donde se desarrolla el proyecto productivo está ubicado en una zona que permite la actividad productiva de acuerdo con los requerimientos de uso del suelo y las determinantes ambientales.",
      "El predio en donde se desarrolla el proyecto productivo se ajusta a la vocación, el uso del suelo y el ordenamiento real del territorio",
      "El predio donde se implementa el proyecto productivo cumple con las condiciones técnicas requeridas para el funcionamiento del modelo productivo (Servicios públicos, infraestructura productiva, área, etc.)",
      "Las condiciones de tenencia del predio donde se ubica el proyecto productivo brindan seguridad jurídica para su adecuado desarrollo y cumplimiento de los objetivos productivos y financieros.",
      "La ubicación del predio donde actualmente se implementa el proyecto productivo facilita el proceso de comercialización y provisión para la competitividad",
    ],
  },
  {
    factor: "Factor 7. Seguridad",
    subfactores: [
      "El proyecto productivo puede seguir siendo implementado en el lugar donde se ubica bajo las condiciones actuales de seguridad",
      "La forma asociativa o el colectivo de trabajo cuenta con conocimiento de las rutas de atención en riesgos de seguridad y violación de derechos humanos",
    ],
  },
  {
    factor: "Factor 8. Ambiental ",
    subfactores: [
      "El proyecto productivo cumple con las leyes, regulaciones y permisos ambientales aplicables.",
      "El proyecto productivo implementa acciones en relación a la conservación, mitigación, gestión del riesgo y/o compensación ambiental (acciones ambientales).  ",
      "El proyecto productivo realiza acciones de reconversión productiva (transformar el modelo productivo).",
      "El proyecto productivo corresponde a la vocación productiva y ecológica del territorio donde se desarrolla",
    ],
  },
];

export default function AsignacionSostenibilidad({
  open,
  onClose,
  planId = null, // ← null para crear, objeto para editar
  existingPlanCodes = [], // ← para deshabilitar códigos ya usados
  presupuestoPorProyecto = 400_000_000,
}) {
  const [form] = Form.useForm();
  const user = useSelector((s) => s?.auth?.user?.username || "");
  const [loading, setLoading] = useState(false);
  const [participantes, setParticipantes] = useState([]);
  const [productosSostenibilidad, setProductosSostenibilidad] = useState([]);
  const [productosMap, setProductosMap] = useState({});
  const [currentStep, setCurrentStep] = useState(0);
  const [stepsVisible, setStepsVisible] = useState(true);
  // Estado para trackear la sección actual
  const [currentSection, setCurrentSection] = useState(null);
  const [presupuesto, setPresupuesto] = useState(0);
  const [subtotals, setSubtotals] = useState({
    infraestructura: 0,
    activos: 0,
    herramientas: 0,
    insumos: 0,
    gastos: 0,
    contrapartida: 0,
  });
  const proyectado = useMemo(
    () => Object.values(subtotals).reduce((a, b) => a + (+b || 0), 0),
    [subtotals]
  );
  const isExceeding = proyectado > presupuesto;
  const [warn, setWarn] = useState(false);

  const [mode, setMode] = useState("1:1"); // '1:1' | '1:N' | 'N:1'
  const [selectedPlan, setSelectedPlan] = useState([]);
  const [lockedPlanKeys, setLockedPlanKeys] = useState(new Set()); // ← bloqueados tras guardar
  // IDs de productos PO

  const [showPoPicker, setShowPoPicker] = useState(false);

  const isSinglePlanSelection = mode === "1:1" || mode === "1:N";

  const steps = useMemo(
    () => [
      { title: "Proyecto" },
      ...SECTIONS.map((s) => ({ title: s.title })),
      { title: "Conceptos" },
    ],
    []
  );

  const [asignaciones, setAsignaciones] = useState([]); // 👈 estado para guardar la data
  const [modalAsignacionVisible, setModalAsignacionVisible] = useState(false); // 👈 estado para controlar visibilidad del modal

  const [entregas, setEntregas] = useState([]); // 👈 estado para guardar la data
  const [modalEntregaVisible, setModalEntregaVisible] = useState(false); // 👈 estado para controlar visibilidad del modal

  const [hideEmpty, setHideEmpty] = useState(false);

  const [plan, setPlan] = useState(null);
  const [loadingPlan, setLoadingPlan] = useState(false);

  // Estado para controlar qué filas están en modo edición
  const [editingRows, setEditingRows] = useState(new Set());

  // Función para activar modo edición
  const handleEditRow = (rowKey) => {
    const newEditingRows = new Set(editingRows);
    newEditingRows.add(rowKey);
    setEditingRows(newEditingRows);
  };

  const handleSaveRow = async (rowKey, nameKey, name) => {
    try {
      // ✅ Validar campos antes de guardar
      await form.validateFields([
        [nameKey, name, "factor"],
        [nameKey, name, "subfactor"],
      ]);

      // ✅ Obtener los valores actuales del formulario
      const allValues = form.getFieldsValue();
      const itemData = allValues[nameKey]?.[name];

      // ✅ Preparar los datos para enviar al backend
      const payload = {
        oid: plan?.oid, // id del plan (registro principal)
        title: itemData?.concepto, // sección del plan (ej: "A. Infraestructura")
        oidProducto: itemData?.oidPlanItem,
        factor: itemData?.factor || null,
        subfactor: itemData?.subfactor || null,
      };

      // ✅ Llamar al servicio
      const response = await actualizarFactorSubfactorPlanCompraService(
        payload
      );

      if (response.success) {
        message.success(response.message || "Cambios guardados correctamente");
        const newEditingRows = new Set(editingRows);
        newEditingRows.delete(rowKey);
        setEditingRows(newEditingRows);
      } else {
        message.error(response.message || "Error al actualizar el producto");
      }
    } catch (error) {
      console.error("❌ Error al guardar:", error);
      if (error.errorFields) {
        message.error("Por favor complete todos los campos requeridos");
      } else {
        message.error("Error al guardar los cambios");
      }
    }
  };

  // Función para cancelar edición
  const handleCancelEdit = (rowKey, nameKey, name) => {
    const newEditingRows = new Set(editingRows);
    newEditingRows.delete(rowKey);
    setEditingRows(newEditingRows);

    // Opcional: recargar valores originales del form
    // form.resetFields([[nameKey, name, 'factor'], [nameKey, name, 'subfactor']]);

    message.info("Edición cancelada");
  };
  useEffect(() => {
    setWarn(isExceeding);
  }, [isExceeding]);

  const fetchPlan = async () => {
    try {
      setLoadingPlan(true);

      // 👇 Llamada al service
      const response = await getPlanCompraSostenibilidadById(planId);

      if (response?.status === 200) {
        // ⚠️ Si la API devuelve lista de planes, selecciona el que necesites
        const planEncontrado = response.data?.[0] ?? null;
        setPlan(planEncontrado);
      } else {
        console.error("No se pudo cargar el plan:", response?.message);
        setPlan(null);
      }
    } catch (err) {
      console.error("Error al cargar el plan:", err);
      setPlan(null);
    } finally {
      setLoadingPlan(false);
    }
  };

  useEffect(() => {
    if (!open) return;
    fetchPlan();
  }, [open, planId]);

  // Cargar participantes + productos una sola vez al abrir
  useEffect(() => {
    if (!open) return;
    let mounted = true;
    (async () => {
      try {
        setLoading(true);
        const [respP, respProd] = await Promise.all([
          getParticipantesSostenibilidad(),
          getProductos(),
        ]);

        // participantes
        if (respP?.status === 200) {
          const opts = respP.data.map((i) => ({
            value: i.codigoInterno,
            label: `${i.codigoInterno} - ${i.nombre} - ${i.implementador}`,
          }));
          if (mounted) setParticipantes(opts);
        }

        // productos
        if (respProd) {
          const opts = respProd.map((it) => ({
            value: it.oid,
            label: `${it.codigo} - ${it.nombre_producto}`,
          }));
          const map = respProd.reduce((acc, it) => {
            acc[it.oid] = it;
            return acc;
          }, {});
          if (mounted) {
            setProductosSostenibilidad(opts);
            setProductosMap(map);
          }
        }
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => {
      mounted = false;
    };
  }, [open]);

  // helper: asegura que cada item tenga un uid estable
  const ensureUid = (arr = []) =>
    arr.map((it) =>
      it?.uid
        ? it
        : {
            ...it,
            uid: crypto?.randomUUID?.() || `${Date.now()}-${Math.random()}`,
          }
    );

  // Si es edición, hidratar formulario
  // Si es edición, hidratar formulario
  useEffect(() => {
    if (!open) return;
    form.resetFields();
    setCurrentStep(0);
    setSubtotals({
      infraestructura: 0,
      activos: 0,
      herramientas: 0,
      insumos: 0,
      gastos: 0,
      contrapartida: 0,
    });
    setLockedPlanKeys(new Set());

    // Mapeo de títulos → keys del form
    const mapSection = {
      "A. Infraestructura": "infraestructura",
      "B. Activos Productivos y equipos": "activos",
      "C. Herramientas y Mobiliario": "herramientas",
      "D. Insumos": "insumos",
      "E. Gastos Operativos": "gastos",
      "F. Contrapartida": "contrapartida",
    };

    if (plan) {
      // Estado inicial del form
      const init = {
        codigoInterno: (plan.codigoInterno || "").split(",").filter(Boolean),
        infraestructura: [],
        activos: [],
        herramientas: [],
        insumos: [],
        gastos: [],
        contrapartida: [],
      };

      (plan.dataItems || []).forEach((sec) => {
        const key = mapSection[sec.title];
        if (!key) return;

        const items = (sec.items || []).map((it) => ({
          uid:
            it.uid ||
            crypto?.randomUUID?.() ||
            `${Date.now()}-${Math.random()}`,
          descripcion: it.oidProducto ?? it.oid ?? it.descripcion ?? null,
          recurso: it.recurso ?? "",
          unidad: it.nombreUnidadMedida ?? it.unidad ?? "",
          cantidad: it.cantidad ?? 0,
          valorUnitario: +(it.valorUnitario ?? it.precio_unitarioPesos ?? 0),
          valorTotal: +(it.valorTotal ?? 0),
          factor: it.factor ?? null,
          subfactor: it.subfactor ?? null,
          oid_unidad_medida: it.oid_unidad_medida ?? null,

          // 👇 Aquí usamos el título original de la sección
          concepto: sec.title,

          cantidad_asignada: it.cantidad_asignada ?? null,
          cantidad_entregada: it.cantidad_entregada ?? null,
          id_asignaciones: it.id_asignaciones ?? null,
          id_entregas: it.id_entregas ?? null,
          oidPlanItem: it.oidPlanItem ?? it.oidProducto ?? it.oid ?? null,
        }));

        // Puedes seguir usando 'key' para identificar el bloque dentro del objeto inicial
        init[key] = ensureUid(items);
      });

      // Setear valores en el form
      form.setFieldsValue(init);

      // Presupuesto
      const cods = init.codigoInterno || [];
      setPresupuesto(cods.length * presupuestoPorProyecto);

      // Subtotales desde conceptoInversion
      const newSubs = {
        infraestructura: 0,
        activos: 0,
        herramientas: 0,
        insumos: 0,
        gastos: 0,
        contrapartida: 0,
      };

      (plan.conceptoInversion || []).forEach((c) => {
        if (c.concepto === "A. Infraestructura")
          newSubs.infraestructura = c.valor;
        if (c.concepto === "B. Activos Productivos y equipos")
          newSubs.activos = c.valor;
        if (c.concepto === "C. Herramientas y Mobiliario")
          newSubs.herramientas = c.valor;
        if (c.concepto === "D. Insumos") newSubs.insumos = c.valor;
        if (c.concepto === "E. Gastos Operativos") newSubs.gastos = c.valor;
        if (c.concepto === "F. Contrapartida") newSubs.contrapartida = c.valor;
      });
      setSubtotals(newSubs);
    } else {
      // creación (sin plan)
      form.setFieldsValue({
        codigoInterno: [],
        infraestructura: [],
        activos: [],
        herramientas: [],
        insumos: [],
        gastos: [],
        contrapartida: [],
      });
      setPresupuesto(0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, plan]);

  const calcSubtotal = (key) => {
    const list = form.getFieldValue(key) || [];
    const total = list.reduce((a, it) => a + (Number(it?.valorTotal) || 0), 0);
    setSubtotals((s) => ({ ...s, [key]: total }));
  };

  const showProd = (prod) => {
    if (!prod) return;
    Modal.info({
      title: "Detalle de producto",
      width: "70%",
      content: (
        <div style={{ lineHeight: 1.4 }}>
          <p>
            <b>Descripción:</b> {prod.descripcion_producto || "—"}
          </p>
          <p>
            <b>Unidad:</b> {prod.nombreUnidadMedida || "—"}
          </p>
          <p>
            <b>Código:</b> {prod.codigo || "—"}
          </p>
          <p>
            <b>Precio ref.:</b> {CURRENCY(prod.precio_unitarioPesos)}
          </p>
        </div>
      ),
    });
  };

  const handleVerAsignaciones = async (ids) => {
    try {
      if (!ids || ids.length === 0) {
        message.warning("⚠️ No hay asignaciones registradas");
        return;
      }

      setLoading(true);

      const response = await getAsignacionesByIds(ids);

      // Validar respuesta
      if (response?.status === 200 && Array.isArray(response.data)) {
        setAsignaciones(response.data); // ✅ Guardar asignacionmos data en estado
        setModalAsignacionVisible(true); // ✅ Mostramos modal
      } else {
        const errorMsg =
          response?.message || "❌ Error desconocido al obtener asignaciones";
        message.error(errorMsg);
        console.error("❌ Error en respuesta de asignaciones:", response);
        setAsignaciones([]); // Limpiar asignaciones
        setModalAsignacionVisible(false);
      }
    } catch (error) {
      console.error("❌ Excepción al cargar asignaciones:", error);
      message.error(
        error?.message || "Error inesperado al cargar asignaciones"
      );
      setAsignaciones([]);
      setModalAsignacionVisible(false);
    } finally {
      setLoading(false);
    }
  };

  const handleVerEntregas = async (ids) => {
    try {
      if (!ids || ids.length === 0) {
        message.warning("⚠️ No hay entregas registradas");
        return;
      }

      setLoading(true);

      const response = await getSalidasByIds(ids);

      // Validar respuesta
      if (response?.status === 200 && Array.isArray(response.data)) {
        setEntregas(response.data); // ✅ Guardamos data en estado
        setModalEntregaVisible(true); // ✅ Mostramos modal
      } else {
        const errorMsg =
          response?.message || "❌ Error desconocido al obtener entregas";
        message.error(errorMsg);
        console.error("❌ Error en respuesta de entregas:", response);
        setEntregas([]); // Limpiar asignaciones
        setModalEntregaVisible(false);
      }
    } catch (error) {
      console.error("❌ Excepción al cargar entregas:", error);
      message.error(error?.message || "Error inesperado al cargar entregas");
      setEntregas([]);
      setModalEntregaVisible(false);
    } finally {
      setLoading(false);
    }
  };
  const SectionList = ({ nameKey }) => {
    const values = form.getFieldValue(nameKey) || [];

    return (
      // En el JSX del Form.List
      <Form.List name={nameKey}>
        {(fields, { remove }) => (
          <>
            {fields.length > 0 && (
              <Row
                gutter={24}
                align="middle"
                style={{ fontWeight: "bold", marginBottom: 10 }}
              >
                <Col span={3}></Col>
                <Col span={5}>Descripción</Col>
                <Col span={3}>Unidad</Col>
                <Col span={2}>Cantidad</Col>
                <Col span={3}>Factor</Col>
                <Col span={4}>Sub factor</Col>
                <Col span={2}>Asignaciones</Col>
                <Col span={2}>Entregas</Col>
              </Row>
            )}

            {fields.map(({ key, name, ...rest }) => {
              const curId = values?.[name]?.descripcion;
              const prod = productosMap[curId] || {};
              const item = values?.[name] || {};
              const uid = item?.uid;
              const rowKey = `${nameKey}:${uid}`;
              const isEditing = editingRows.has(rowKey);
              const isLocked = lockedPlanKeys.has(rowKey);

              return (
                <Row
                  key={rowKey}
                  gutter={24}
                  align="top"
                  className={`asignacion-sostenibilidad ${
                    isLocked ? "row-bloqueada" : ""
                  }`}
                  style={{
                    backgroundColor: isLocked ? "#28a74524" : "transparent",
                    borderLeft: isLocked ? "4px solid #28a745" : "none",
                  }}
                >
                  <Col
                    span={3}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "6px",
                    }}
                  >
                    <Checkbox
                      checked={selectedPlan.includes(rowKey)}
                      disabled={
                        isLocked ||
                        (isSinglePlanSelection &&
                          selectedPlan.length === 1 &&
                          !selectedPlan.includes(rowKey))
                      }
                      onChange={(e) =>
                        handlePlanToggle(rowKey, e.target.checked)
                      }
                    />
                    {curId && (
                      <Button
                        type="link"
                        icon={<FileSearchOutlined />}
                        onClick={() => showProd(prod)}
                        style={{ fontSize: 23 }}
                      />
                    )}

                    <Space>
                      {!isEditing ? (
                        <Button
                          type="primary"
                          size="small"
                          icon={<EditOutlined />}
                          onClick={() => handleEditRow(rowKey)}
                          disabled={isLocked}
                        ></Button>
                      ) : (
                        <>
                          <Button
                            type="primary"
                            size="small"
                            icon={<SaveOutlined />}
                            onClick={() => handleSaveRow(rowKey, nameKey, name)}
                          ></Button>
                          <Button
                            size="small"
                            icon={<CloseOutlined />}
                            onClick={() =>
                              handleCancelEdit(rowKey, nameKey, name)
                            }
                          ></Button>
                        </>
                      )}
                    </Space>
                  </Col>

                  <Col span={5}>
                    <Form.Item
                      {...rest}
                      name={[name, "descripcion"]}
                      rules={[
                        { required: true, message: "Seleccione un producto" },
                      ]}
                    >
                      <Select
                        disabled
                        className="disabled-element"
                        showSearch
                        placeholder="Seleccione un producto"
                        optionFilterProp="label"
                        optionLabelProp="label"
                        notFoundContent={loading ? <Spin size="small" /> : null}
                        options={productosSostenibilidad}
                        onChange={(value) => {
                          const arr = [...(form.getFieldValue(nameKey) || [])];
                          const cur = arr[name] || {};
                          const p = productosMap[value] || {};
                          arr[name] = {
                            ...cur,
                            descripcion: value,
                            unidad: p.nombreUnidadMedida || cur.unidad || "",
                            oid_unidad_medida:
                              p.oid_unidad_medida ??
                              cur.oid_unidad_medida ??
                              null,
                            valorUnitario: +(
                              (cur.valorUnitario ?? p.precio_unitarioPesos) ||
                              0
                            ),
                            valorTotal:
                              (cur.cantidad ? +cur.cantidad : 0) *
                              +(
                                (cur.valorUnitario ?? p.precio_unitarioPesos) ||
                                0
                              ),
                          };
                          form.setFieldsValue({ [nameKey]: arr });
                          calcSubtotal(nameKey);
                        }}
                        style={{ color: "#000" }}
                      />
                    </Form.Item>
                  </Col>

                  <Col span={3}>
                    <Form.Item {...rest} name={[name, "unidad"]}>
                      <Input disabled placeholder="Unidad" />
                    </Form.Item>
                  </Col>

                  <Col span={2}>
                    <Form.Item {...rest} name={[name, "cantidad"]}>
                      <InputNumber
                        disabled
                        min={1}
                        style={{ width: "100%", textAlign: "center" }}
                        className="disabled-element"
                        onChange={(val) => {
                          const arr = [...(form.getFieldValue(nameKey) || [])];
                          const cur = arr[name] || {};
                          const vunit = +(cur.valorUnitario || 0);
                          arr[name] = {
                            ...cur,
                            cantidad: val,
                            valorTotal: +(val || 0) * vunit,
                          };
                          form.setFieldsValue({ [nameKey]: arr });
                          calcSubtotal(nameKey);
                        }}
                      />
                    </Form.Item>
                  </Col>

                  {/* Factor - Habilitado solo en modo edición */}
                  <Col span={3}>
                    <Form.Item
                      {...rest}
                      name={[name, "factor"]}
                      rules={[
                        { required: true, message: "Seleccione un factor" },
                      ]}
                    >
                      <Select
                        disabled={!isEditing}
                        className={!isEditing ? "disabled-element" : ""}
                        placeholder="Seleccione un factor"
                        options={factores.map((f) => ({
                          label: f.factor,
                          value: f.factor,
                        }))}
                        onChange={() => {
                          // Limpiar subfactor cuando cambia el factor
                          const arr = [...(form.getFieldValue(nameKey) || [])];
                          arr[name] = { ...arr[name], subfactor: undefined };
                          form.setFieldsValue({ [nameKey]: arr });
                        }}
                      />
                    </Form.Item>
                  </Col>

                  {/* Subfactor - Habilitado solo en modo edición */}
                  <Col span={4}>
                    <Form.Item
                      noStyle
                      shouldUpdate={(prevValues, currentValues) =>
                        prevValues[nameKey]?.[name]?.factor !==
                        currentValues[nameKey]?.[name]?.factor
                      }
                    >
                      {({ getFieldValue }) => {
                        const factorSeleccionado = getFieldValue([
                          nameKey,
                          name,
                          "factor",
                        ]);
                        const subfactores =
                          factores.find((f) => f.factor === factorSeleccionado)
                            ?.subfactores || [];

                        return (
                          <Form.Item
                            {...rest}
                            name={[name, "subfactor"]}
                            rules={[
                              {
                                required: true,
                                message: "Seleccione un subfactor",
                              },
                            ]}
                          >
                            <Select
                              disabled={!isEditing || !factorSeleccionado}
                              className={!isEditing ? "disabled-element" : ""}
                              placeholder="Seleccione un subfactor"
                              options={subfactores.map((sf) => ({
                                label: sf,
                                value: sf,
                              }))}
                            />
                          </Form.Item>
                        );
                      }}
                    </Form.Item>
                  </Col>

                  <Col span={2}>
                    <Space.Compact style={{ width: "100%" }}>
                      <Form.Item
                        {...rest}
                        name={[name, "cantidad_asignada"]}
                        noStyle
                      >
                        <InputNumber
                          disabled
                          min={1}
                          style={{ textAlign: "center", width: "100%" }}
                          className="disabled-element"
                        />
                      </Form.Item>
                      <Form.Item shouldUpdate noStyle>
                        {({ getFieldValue }) => {
                          const arr = getFieldValue(nameKey) || [];
                          const value = arr?.[name]?.cantidad_asignada;
                          return value && value > 0 ? (
                            <Button
                              shape="circle"
                              type="text"
                              size="small"
                              icon={
                                <EyeOutlined
                                  style={{ fontSize: 16, color: "#1890ff" }}
                                />
                              }
                              onClick={() =>
                                handleVerAsignaciones(
                                  arr?.[name]?.id_asignaciones || []
                                )
                              }
                            />
                          ) : null;
                        }}
                      </Form.Item>
                    </Space.Compact>
                  </Col>

                  <Col span={2}>
                    <Space.Compact style={{ width: "100%" }}>
                      <Form.Item
                        {...rest}
                        name={[name, "cantidad_entregada"]}
                        noStyle
                      >
                        <InputNumber
                          disabled
                          min={1}
                          style={{ textAlign: "center", width: "100%" }}
                          className="disabled-element"
                        />
                      </Form.Item>
                      <Form.Item shouldUpdate noStyle>
                        {({ getFieldValue }) => {
                          const arr = getFieldValue(nameKey) || [];
                          const value = arr?.[name]?.cantidad_entregada;
                          return value && value > 0 ? (
                            <Button
                              shape="circle"
                              type="text"
                              size="small"
                              icon={
                                <EyeOutlined
                                  style={{ fontSize: 16, color: "#1890ff" }}
                                />
                              }
                              onClick={() =>
                                handleVerEntregas(
                                  arr?.[name]?.id_entregas || []
                                )
                              }
                            />
                          ) : null;
                        }}
                      </Form.Item>
                    </Space.Compact>
                  </Col>

                </Row>
              );
            })}
          </>
        )}
      </Form.List>
    );
  };

  const toggleSteps = () => setStepsVisible((v) => !v);

  const isValidSelection = (mode, sp, spo) => {
    if (mode === "1:1") return sp.length === 1 && spo.length === 1;
    if (mode === "1:N") return sp.length === 1 && spo.length >= 1;
    if (mode === "N:1") return sp.length >= 1 && spo.length === 1;
    return false;
  };

  const handlePlanToggle = (rowKey, checked) => {
    setSelectedPlan((prev) => {
      if (!checked) return prev.filter((k) => k !== rowKey); // quitar

      // Añadir con reglas por modo:
      if (isSinglePlanSelection) {
        // Modo selección única: reemplaza por la nueva
        return [rowKey];
      } else {
        // N:1 → múltiple
        return [...new Set([...prev, rowKey])];
      }
    });
  };

  useEffect(() => {
    if ((mode === "1:1" || mode === "1:N") && selectedPlan.length > 1) {
      setSelectedPlan([selectedPlan[0]]);
    }
  }, [mode, selectedPlan]);

  const buildPlanSelectionObjects = () => {
    const out = [];

    for (const key of selectedPlan) {
      const [sectionKey, uid] = String(key).split(":");
      const arr = form.getFieldValue(sectionKey) || [];
      const item = arr.find((it) => it?.uid === uid);
      if (!item) continue;

      const p = productosMap?.[item.descripcion] || {}; // puede ser undefined
      const codigo = p.codigo ? `${p.codigo} - ` : "";
      const nombre = p.nombre_producto || item.nombre || "(sin nombre)";

      out.push({
        oidPlanItem: item.descripcion ?? null, // OID del producto
        label: `${codigo}${nombre}`, // ← concatenación correcta
        unidad: item.unidad || p.nombreUnidadMedida || "",
        cantidad: item.cantidad ?? null,
      });
    }

    return out;
  };

  // helper: busca un item del plan por OID (ej. 4502) dentro de plan.dataItems
  const findPlanItemByOid = (oid) => {
    for (const sec of plan?.dataItems || []) {
      for (const it of sec.items || []) {
        const oidIt = it.oidProducto ?? it.oid;
        if (Number(oidIt) === Number(oid))
          return { sectionTitle: sec.title, ...it };
      }
    }
    return null;
  };

  // Función auxiliar: dado un oidPlanItem, devuelve su rowKey en el árbol
  // Dado un oidPlanItem (número), devuelve rowKey "sectionKey:uid" si lo encuentra.
  // Busca en los arrays actuales del form: infraestructura, activos, herramientas, etc.
  const getRowKeyByOidPlanItem = (oid) => {
    const oidNum = Number(oid);

    for (const s of SECTIONS) {
      const arr = form.getFieldValue(s.key) || [];

      // Ajusta aquí los posibles nombres que traen el OID en tu form
      const foundIndex = arr.findIndex(
        (it) =>
          Number(
            it?.oidPlanItem ??
              it?.descripcion ?? // en tu modelo suele estar el OID de producto aquí
              it?.oidProducto ??
              it?.oid
          ) === oidNum
      );

      if (foundIndex !== -1) {
        const item = arr[foundIndex];

        // 1) Preferimos uid estable (deberías haberlo agregado al hidratar/crear filas)
        if (item?.uid) {
          return `${s.key}:${item.uid}`;
        }

        // 2) Fallback SEGURO (si por algún dato viejo no hay uid):
        //    - intenta generar un uid in-memory consistente
        //    - o como última opción, usa el índice (no ideal, pero no rompe tu flujo)
        //    Si no quieres mutar el form aquí, no lo hagas; solo retorna con índice.
        return `${s.key}:${foundIndex}`;
      }
    }

    return null; // no encontrado
  };

  const handleSave = async ({ mode, planIds, poRows }) => {
    // 1) Snapshot del/los ítems de plan:
    const planItemsSnapshot = (planIds || [])
      .map((id) => findPlanItemByOid(id))
      .filter(Boolean)
      .map((it) => ({
        oidPlanItem: it.oidProducto ?? it.oid ?? null,
        section: it.sectionTitle || null,
        codigo: it.codigo ?? null,
        nombre: it.nombre_producto ?? it.descripcion_producto ?? null,
        unidad: it.nombreUnidadMedida ?? it.unidad ?? null,
        cantidadSolicitada: it.cantidad ?? null,
        valorUnitario: it.valorUnitario ?? it.precio_unitarioPesos ?? null,
      }));

    // (Opcional) evita mandar el plan completo si es gigante:
    const planSnapshot = {
      oid: plan?.oid ?? null,
      codigoInterno: plan?.codigoInterno ?? null,
      poRows: poRows,
      mode: mode,
      planIds: planIds,
      productos: planItemsSnapshot,
    };

    // 4) JSON de auditoría (todo junto)
    const auditJson = {
      mode,
      usuario: user,
      fecha: new Date().toISOString(),
      plan: planSnapshot,
      planItems: planItemsSnapshot,
    };

    try {
      setLoading(true);
      const resp = await postAsignaciones({
        mode,
        planIds,
        poRows,
        meta: {
          usuario: user, // 👈 asegurado
          dataInfo: auditJson,
        },
      });

      if (resp.statusCode === 201 || resp.statusCode === 200) {
        message.success(resp.message || "Asignaciones creadas correctamente");

        fetchPlan(); // Refrescar plan con asignaciones actualizadas
        // Bloquear ítems del plan ya asignados:
        // Bloquear ítems del plan ya asignados (rowKeys estables + fallback por OID)
        setLockedPlanKeys((prev) => {
          const next = new Set(prev);

          // a) bloquea exactamente los que el usuario seleccionó (rowKey = sectionKey:uid)
          for (const rk of selectedPlan) {
            next.add(rk);
          }

          // b) fallback: si te llegan OIDs (p.ej. desde backend), mapea a rowKey actual
          for (const oid of planIds || []) {
            const rk = getRowKeyByOidPlanItem(oid); // nueva versión (ver abajo)
            if (rk) next.add(rk);
          }

          return next;
        });

        // Limpiar selección y cerrar modal
        setSelectedPlan([]);
        setShowPoPicker(false);
      } else if (resp.statusCode >= 400 && resp.statusCode < 500) {
        message.warning(resp.message || "Solicitud inválida");
      } else {
        message.error(resp.message || "Error al crear asignaciones");
      }
    } catch (e) {
      // e = { statusCode, status, message, data }
      if (e.statusCode === 400) {
        message.warning(e.message || "Solicitud inválida (400)");
      } else if (e.statusCode >= 500) {
        message.error(e.message || "Error interno del servidor");
      } else {
        message.error(e.message || "Error de red");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteAsignacion = async (oid) => {
    try {
      const resp = await deleteAsignacionById(oid);

      if (resp.success) {
        message.success(resp.message);

        // ✅ actualizar el estado en el padre

        setAsignaciones((prev) => prev.filter((a) => a.id !== oid));
        fetchPlan(); // Refrescar plan con asignaciones actualizadas

        // opcional: refrescar desde backend
        // cargarDatos();
      } else {
        message.error("No se pudo eliminar la asignación.");
      }
    } catch (error) {
      message.error("No se pudo eliminar la asignación.");
    }
  };

  const onFetchDisponible = async (oid) => {
    try {
      const resp = await getCounDisponibleProductPOById(oid);

      if (resp.success) {
        return resp.data.cantidad_disponible; // Debe retornar un número
      } else {
        message.error("No se pudo eliminar la asignación.");
      }
    } catch (error) {
      message.error("No se pudo eliminar la asignación.");
    }
  };

  const handleUpdateAsignacion = async (cantidad_asignar, record) => {
    try {
      const resp = await updateAsignacionById(
        record.asignacion_id,
        cantidad_asignar,
        record.oidStockLote,
        record.oidPlanItem
      );

      if (resp.success) {
        message.success(resp.message);

        // ✅ actualizar el estado en el padre sin eliminar, sino reemplazando
        setAsignaciones((prev) =>
          prev.map((a) =>
            a.id === record.asignacion_id
              ? {
                  ...a,
                  cantidad_asignada: cantidad_asignar,
                }
              : a
          )
        );

        fetchPlan(); // Refrescar plan con asignaciones actualizadas

        // opcional: refrescar desde backend
        // cargarDatos();
      } else {
        message.error("No se pudo eliminar la asignación.");
      }
    } catch (error) {
      message.error("No se pudo eliminar la asignación.");
    }
  };

  return (
    <>
      <Drawer
        title={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
              position: "relative",
            }}
          >
            <h6 style={{ margin: 0, fontWeight: "bold", paddingRight: 50 }}>
              Asignación de productos - Plan de Compras: {plan?.codigoInterno}
            </h6>
            <Button
              icon={<CloseOutlined />}
              onClick={() => onClose()}
              style={{
                position: "absolute",
                right: 0,
                top: "50%",
                transform: "translateY(-50%)",
                border: "none",
                boxShadow: "none",
              }}
            />
          </div>
        }
        placement="right"
        open={open}
        closable={false}
        width="100vw" // 100% del ancho de la pantalla
        rootStyle={{ top: 0 }} // sin margen superior
        destroyOnClose
        maskClosable
        styles={{
          body: {
            padding: 1,
            height: "calc(100vh - 55px)", // alto útil del body (resta el header del Drawer)
            overflow: "auto",
          },
          header: { marginBottom: 0 },
        }}
        zIndex={900}
      >
        <div
          style={{
            position: "sticky",
            top: 0, // se pega al tope del contenedor con scroll
            zIndex: 1, // por encima de las cards
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            gap: 16,
            marginBottom: 16,
            padding: 12, // opcional, para que no quede “pegado”
            background: "#fff", // importante: fondo sólido para que no “transparente”
            borderBottom: "1px solid #f0f0f0",
            boxShadow: "0 2px 4px rgba(0,0,0,0.04)", // opcional
          }}
        >
          <Space>
            <Button
              onClick={() => setHideEmpty((v) => !v)}
              style={{
                backgroundColor: hideEmpty ? "#28a745" : "#1890ff", // verde o azul
                color: "#fff",
                border: "none",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = hideEmpty
                  ? "#218838"
                  : "#40a9ff";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = hideEmpty
                  ? "#28a745"
                  : "#1890ff";
              }}
            >
              {hideEmpty ? "Mostrar todo" : "Ocultar vacíos"}
            </Button>

            <Segmented
              value={mode}
              onChange={setMode}
              className="custom-segmented"
              options={[
                {
                  label: <Tooltip title="1 del plan ↔ 1 PO">1:1</Tooltip>,
                  value: "1:1",
                },
                {
                  label: <Tooltip title="1 del plan ↔ varios PO">1:N</Tooltip>,
                  value: "1:N",
                },
                {
                  label: <Tooltip title="Varios del plan ↔ 1 PO">N:1</Tooltip>,
                  value: "N:1",
                },
              ]}
            />
            <Button
              onClick={() => setShowPoPicker(true)}
              disabled={selectedPlan.length === 0}
            >
              Seleccionar productos PO
            </Button>
            <Button onClick={() => setSelectedPlan([])}>
              Limpiar selección
            </Button>
          </Space>
        </div>

        {/* 👇 Contenido sin panel de navegación */}

        {loading && <Spin fullscreen tip="Cargando datos..." />}
        <div style={{ flex: 1, padding: 16, overflowY: "auto", minHeight: 0 }}>
          <Form
            form={form}
            layout="vertical"
            className="asignacion-sostenibilidad"
            initialValues={{
              codigoInterno: [],
              infraestructura: [],
              activos: [],
              herramientas: [],
              insumos: [],
              gastos: [],
              contrapartida: [],
            }}
            onValuesChange={(cv) => {
              const k = Object.keys(cv || {})[0];
              if (SECTIONS.some((s) => s.key === k)) calcSubtotal(k);
            }}
          >
            {/* Proyecto seleccionado */}
            <div style={{ marginBottom: 24 }}>
              <Row gutter={16} align="middle">
                <Col xs={24} md={12}>
                  <h4
                    style={{
                      background: "#ced4da2b",
                      borderRadius: 10,
                      padding: "8px 12px",
                      margin: 0, // importante para centrar bien
                      fontWeight: "bold",
                      textAlign: "center",
                    }}
                  >
                    Proyecto seleccionado
                  </h4>
                </Col>

                <Col xs={24} md={12}>
                  <Form.Item
                    name="codigoInterno"
                    rules={[
                      {
                        required: true,
                        message: "Seleccione al menos un proyecto",
                      },
                      {
                        validator: (_, v) =>
                          Array.isArray(v) &&
                          v.some((x) => !/^ES-\d{4}$/.test(x))
                            ? Promise.reject("Formato inválido. Ej: ES-0003")
                            : Promise.resolve(),
                      },
                    ]}
                  >
                    <Select
                      disabled
                      className="disabled-element"
                      mode="multiple"
                      showSearch
                      placeholder="Seleccione uno o varios códigos internos"
                      optionFilterProp="label"
                      loading={loading}
                      style={{ width: "100%" }}
                      options={participantes.map((p) => ({
                        ...p,
                        disabled: existingPlanCodes.includes(p.value),
                      }))}
                      onChange={(vals) =>
                        setPresupuesto(
                          (vals?.length || 0) * presupuestoPorProyecto
                        )
                      }
                    />
                  </Form.Item>
                </Col>
              </Row>
            </div>

            {/* 👇 Todas las secciones listadas con título */}
            {SECTIONS.filter((s) => {
              if (!hideEmpty) return true;
              const count = (form.getFieldValue(s.key) || []).length;
              return count > 0; // solo mostrar si tiene elementos
            }).map((s) => (
              <section key={s.key} id={s.key} style={{ marginBottom: 24 }}>
                <h5
                  style={{
                    fontSize: 18,
                    padding: "2px 10px",
                    background: "#28a745",
                    color: "#FFF",
                    borderRadius: 10,
                  }}
                >
                  {s.title}
                </h5>
                <SectionList nameKey={s.key} />
              </section>
            ))}

            {/* Resumen y botón Finalizar */}
            <div style={{ marginTop: 16 }}>
              <h5
                style={{
                  fontSize: "18px",
                  padding: "2px 10px",
                  background: "#28a745",
                  color: "#FFF",
                  borderRadius: 10,
                  paddingLeft: 5,
                }}
              >
                Concepto de la inversión
              </h5>
              <Table
                pagination={false}
                dataSource={[
                  {
                    key: "1",
                    concepto: "A. Infraestructura",
                    valor: subtotals.infraestructura,
                  },
                  {
                    key: "2",
                    concepto: "B. Activos Productivos y equipos",
                    valor: subtotals.activos,
                  },
                  {
                    key: "3",
                    concepto: "C. Herramientas y Mobiliario",
                    valor: subtotals.herramientas,
                  },
                  {
                    key: "4",
                    concepto: "D. Insumos",
                    valor: subtotals.insumos,
                  },
                  {
                    key: "5",
                    concepto: "E. Gastos Operativos",
                    valor: subtotals.gastos,
                  },
                  {
                    key: "6",
                    concepto: "F. Contrapartida",
                    valor: subtotals.contrapartida,
                  },
                  { key: "7", concepto: "TOTAL PROYECTO", valor: proyectado },
                ].map((r) => ({
                  ...r,
                  porcentaje:
                    r.key === "7"
                      ? "100%"
                      : `${((r.valor / (proyectado || 1)) * 100).toFixed(2)}%`,
                }))}
                columns={[
                  { title: "Concepto", dataIndex: "concepto" },
                  {
                    title: "Valor Cofinanciación y Contrapartida",
                    dataIndex: "valor",
                    align: "right",
                    render: (v) => CURRENCY(v),
                  },
                  {
                    title: "% del total del proyecto",
                    dataIndex: "porcentaje",
                    align: "center",
                  },
                ]}
                rowClassName={(rec) => (rec.key === "7" ? "total-row" : "")}
                style={{ marginBottom: 20 }}
                size="small"
              />

              {isExceeding ? (
                <p style={{ color: "red", fontWeight: "bold" }}>
                  El proyectado excede el presupuesto asignado.
                </p>
              ) : proyectado === 0 ? (
                <p style={{ color: "red", fontWeight: "bold" }}>
                  El proyectado no puede ser cero.
                </p>
              ) : (
                <Button type="primary" onClick={onClose}>
                  Finalizar
                </Button>
              )}
            </div>
          </Form>
        </div>
      </Drawer>

      <Modal
        title="Advertencia: Presupuesto excedido"
        open={warn}
        onOk={() => setWarn(false)}
        onCancel={() => setWarn(false)}
        okText="Entendido"
        cancelText="Cerrar"
      >
        <p>El valor proyectado no puede ser mayor que el valor asignado.</p>
        <p>
          <b>Valor asignado:</b> {CURRENCY(presupuesto)}
        </p>
        <p>
          <b>Valor proyectado:</b>{" "}
          <span style={{ color: "red" }}>{CURRENCY(proyectado)}</span>
        </p>
        <p>
          <b>Exceso:</b>{" "}
          <span style={{ color: "red" }}>
            {CURRENCY(proyectado - presupuesto)}
          </span>
        </p>
      </Modal>

      <AsignacionesModal
        visible={modalAsignacionVisible}
        onClose={() => setModalAsignacionVisible(false)}
        asignaciones={asignaciones}
        onDelete={handleDeleteAsignacion} // 🔑 pasamos el callback
        onUpdate={handleUpdateAsignacion}
        onFetchDisponible={onFetchDisponible}
      />

      <EntregasModal
        visible={modalEntregaVisible}
        onClose={() => setModalEntregaVisible(false)}
        entregas={entregas}
      />

      <PoPicker
        open={showPoPicker}
        mode={mode}
        planSelection={buildPlanSelectionObjects()} // <— AQUÍ
        onCancel={() => setShowPoPicker(false)}
        onSave={handleSave}
      />
    </>
  );
}
